
import React from "react";
import { GiPhone } from "react-icons/gi";
import { Link } from "react-router-dom";

export const Footer = ({lang}) => {

  
const navLinks = [
  {
    id: "/",
    title:  lang === 'en' ?  "Home" : " الرئيسية ",
    Children:[]
  },

  
  {
    id: "Products",
    title:  lang === 'en' ? "Products" : "المنتجات",
    Children:[]
  },
  {
    id: "Brands",
    title:  lang === 'en' ? "Brands" : "الوكالات",
    Children:[]
  },
  {
    id: "About",
    title:  lang === 'en' ? "About" : " من نحن",
    Children:[]
  },
  {
    id: "Contact",
    title:  lang === 'en' ? "Contact" : "تواصل",
    Children:[]
  },
];



  return (
    <footer  className=" mt-[8px] p-1 w-full bg-[#1F1F1F]  h-[280px]">
      <div className="flex flex gap-5 justify-between items-center  w-full ">
     
        <div className="flex gap-1 justify-between w-[40%]  my-auto h-[180px] ">
        <img
            src="../../gray-logo.svg"
            className="object-contain  w-[30%]"
            alt="Footer logo"
          />
          <div className="flex flex-col justify-center w-[70%] ">
          <h1 style={{fontFamily:'CairoExtraBold'}}  className="w-full text-white text-[20px]  lg:text-[50px]  md:text-[40px]  sm:text-[30px]  xs:text-[20px] "> {lang === 'en' ? 'Al-Hubaishi' : 'الحبيشـي'}</h1>
            <p style={{fontFamily:'CairoLight'}} className=" w-full  mt-2 text-[10px]  lg:text-[30px]  md:text-[23px]  sm:text-[15px]  xs:text-[10px] text-[#A2A6AC]">
              {lang === 'en' ? 'For a Better Future' : 'من اجل مستقبل افضل'} 
            </p>
          </div>
         
        </div>

        <nav style={{fontFamily:'CairoLight'}} className="flex gap-1 justify-between items-center  my-auto  text-[#A2A6AC]  w-[30%]">
          <div className="flex flex-col justify-center  my-auto w-[50%]">
            <Link to="/#">{navLinks[0].title}</Link>
            <Link to="/Products">{navLinks[1].title}</Link>
            <Link to="/Brands">{navLinks[2].title}</Link>
          </div>
          <div className="flex flex-col justify-center my-auto w-[50%]">   
            <Link to="/About">{navLinks[3].title}</Link>
            <Link to="/Contact">{navLinks[4].title}</Link>
            <Link to="/#Branches">{lang === 'en' ? 'Branches' : 'فروعنا'}</Link>
          </div>
        </nav>

        <div style={{fontFamily:'CairoMedium'}} className="flex flex-col justify-center items-center w-[30%] text-[#A2A6AC] ">
        <h3> {lang === 'en' ? 'Contact us' : 'تواصل معنا على'}</h3>
        <ul  className="w-full  px-[5%] gap-1 flex   mt-2 ">
        <li className="m-auto w-[24px] h-[24px] rounded"><a className="" target='__blink' href="Tel:+967779030000">
            <GiPhone color="#E6324B" size={24} />
             </a></li>

             <li className="m-auto w-[24px] h-[24px] rounded"><a className="" target='__blink' href="https://wa.me/+967779030000">
               <img src='../../Icons/whatsapp.png ' alt="al-hubaishi whatsapp" name="logo-whatsapp" width={24} height={24}  />
             </a></li>
      
             <li className="m-auto w-[24px] h-[24px] rounded"><a className="" target='__blink' href="mailto:info@al-hubaishi.com">
               <img src='../../Icons/gmail.png ' alt="al-hubaishi gmail" name="logo-gmail" width={24} height={24}  />
             </a></li>
          
            
             <li className="m-auto w-[24px] h-[24px] rounded "><a className="" target='__blink' href="https://www.facebook.com/profile.php?id=100076069705620">
          <img src='../../Icons/facebook.png ' alt="al-hubaishi facebook" name="logo-facebook" width={24} height={24}  />
        </a></li>
            
             
         </ul>
        </div>


      </div>
     
 <div className="flex flex-col justify-center w-full w-full mt-2">
        <hr className="flex w-full bg-zinc-400 bg-opacity-50  w-full" />
        
        <div className="flex flex-wrap gap-2 justify-between items-center my-2  w-full p-2 ">
        <p  className="text-[#A2A6AC] ">
              <span className=""> &copy; </span>
              {lang === 'en' ? 'All rights reserved to Al-Habishi Foundation 2025' : 'جميع الحقوق محفوظة لمؤسسة الحبيشي 2025'}
            {" "}
            </p>
          
          
          
          <p className="self-stretch my-auto text-zinc-400">
            {lang === 'en' ? 'Developed by' : 'تطوير'}
            <a  target='__blink' href="https://future-swift.com"><span className="text-white"> {lang === 'en' ? 'Future Swift' : 'فيوتشر سويفت'} </span></a>
          </p>
         
        </div>
      </div>
    </footer>
  );
};
/*

  <div className="self-stretch my-auto text-3xl text-white w-[239px]">
          <h3>تواصل معنا على</h3>
          <div className="flex gap-5 py-px mt-5 w-full min-h-[46px]" />
        </div>





 
      





 <div className="flex flex-col justify-center mt-8 w-full text-xl max-md:max-w-full">
        <hr className="flex w-full bg-zinc-400 bg-opacity-50 min-h-px max-md:max-w-full" />
        <div className="flex flex-wrap gap-10 justify-between items-center mt-7 w-full max-md:max-w-full">
          <p className="self-stretch my-auto text-zinc-400">
            تطوير
            <span className="text-white"> Future Swift</span>
          </p>
          <div className="flex flex-wrap gap-10 justify-between items-center self-stretch my-auto text-white min-w-60 w-[662px] max-md:max-w-full">
            <a href="#" className="self-stretch my-auto">
              الخصوصية و شروط الاستخدام
            </a>
            <p className="gap-3 self-stretch my-auto min-w-60">
              <span className="font-[Century Gothic]">© </span>
              2025 HUBAISHI جميع الحقوق محفوظة{" "}
            </p>
          </div>
        </div>
      </div>
*/